import React, { useState } from 'react'
import { Box, IconButton } from '@material-ui/core'
import Paper from '@material-ui/core/Paper'
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons'
import Typography from '@material-ui/core/Typography'
import AttachFileIcon from '@material-ui/icons/AttachFile';
import NoteIcon from '@material-ui/icons/Note';
import { dateToLocal } from '@auteco/utils/dateToLocal'
import { NotesDialog } from '../NotesDialog'
import { AttachmentsDialog } from '../AttachmentsDialog'
import useStyles from './styles'

const PaperContent = ({ item }) => {
    const [show, setShow] = useState({ description: false, requester: false })
    const [showDialogs, setShowDialogs] = useState({ notes: false, files: false })
    const classes = useStyles()

    const updateShow = ({ param }) => {
        setShow(prev => ({ ...prev, [param]: !prev[param] }))
    }

    const changeNotesDisplay = ({ display, type }) => {
        setShowDialogs(prev => ({ ...prev, [type]: display }))
    }

    const booleanToString = ({ value }) => value ? 'Sí' : 'No'

    return (
        <>
            <NotesDialog
                notes={item.notes}
                open={showDialogs.notes}
                onClose={() => changeNotesDisplay({ display: false, type: 'notes' })}
            />
            <AttachmentsDialog
                files={item.attachments}
                open={showDialogs.files}
                onClose={() => changeNotesDisplay({ display: false, type: 'files' })}
            />
            <Paper
                elevation={3}
                className={classes.paper}
            >
                <Box className={classes.titleContainer}>
                    <Typography className={classes.mainTitle}>
                        {item.subject}
                    </Typography>
                    <div>
                        <IconButton onClick={() => changeNotesDisplay({ display: true, type: 'notes' })}>
                            <NoteIcon />
                        </IconButton>
                        <IconButton onClick={() => changeNotesDisplay({ display: true, type: 'files' })}>
                            <AttachFileIcon />
                        </IconButton>
                    </div>

                    {/* <IconButton onClick={() => expandCard(index)}>
                    <Tooltip title="Expandir/Encoger">
                        {item.statusHeight ? <ArrowDropUp /> : <ArrowDropDown />}
                    </Tooltip>
                </IconButton> */}
                </Box>
                <div>
                    <Typography><span className={classes.subtitle}>Solicitante</span> <IconButton className={classes.iconBtnContent} onClick={() => updateShow({ param: 'requester' })}>{show.requester ? <ArrowDropUp /> : <ArrowDropDown />}</IconButton></Typography>
                    {show.requester &&
                        <>
                            <Typography><span className={classes.subtitle}>Nombre:</span> {item.requester.name}</Typography>
                            <Typography><span className={classes.subtitle}>Correo:</span> {item.requester.email}</Typography>
                            <Typography><span className={classes.subtitle}>Dirección:</span> {item.requester.address}</Typography>
                        </>
                    }
                    <Typography><span className={classes.subtitle}>Descripcion:</span>
                        <IconButton className={classes.iconBtnContent} onClick={() => updateShow({ param: 'description' })}>{show.description ? <ArrowDropUp /> : <ArrowDropDown />}</IconButton></Typography>
                    {show.description &&
                        <Typography>{item.description}</Typography>
                    }
                    <Typography><span className={classes.subtitle}>Número del caso:</span> {item["display-id"]}</Typography>
                    <Typography><span className={classes.subtitle}>Fecha de creación:</span> {dateToLocal(item["created-at"]).formattedDateAndHour}</Typography>
                    <Typography><span className={classes.subtitle}>Fecha de actualización:</span> {dateToLocal(item["updated-at"]).formattedDateAndHour}</Typography>
                    <Typography><span className={classes.subtitle}>Fecha de cierre:</span> {dateToLocal(item["due-by"]).formattedDateAndHour}</Typography>
                    <Typography><span className={classes.subtitle}>Estado de la petición:</span> {item["status-name"]}</Typography>
                    <Typography><span className={classes.subtitle}>Respuesta dada por:</span> {item["responder-name"]}</Typography>
                    <Typography><span className={classes.subtitle}>Etiquetas:</span> {item.tags.map(tag => tag.name)}</Typography>
                    <Typography><span className={classes.subtitle}>Urgente: </span>{booleanToString({ value: item.urgent })}</Typography>
                </div>
            </Paper>
        </>
    )
}

export { PaperContent }
